module.exports = __webpack_public_path__ + "fonts/VetoSansCond-CondLight_1.f5a8e2b6.woff2";